export enum ErrorGaCategory {
  Pages = 'error-pages',
}
